import React, {useEffect, useState} from 'react';

function useDelayUnmount(isMounted, delayTime) {
    const [shouldRender, setShouldRender] = useState(false);
    const [shouldChangeStyle, setShouldChangeStyle] = useState(false);

    useEffect(() => {
        let timeoutId;
        if (isMounted && !shouldRender) {
            setShouldRender(true);
            setShouldChangeStyle(true);
        } else if (!isMounted && shouldRender) {
            timeoutId = setTimeout(
                () => setShouldRender(false),
                delayTime
            );
            setShouldChangeStyle(false);
        }
        return () => clearTimeout(timeoutId);
    }, [isMounted, delayTime, shouldRender, shouldChangeStyle]);
    return [shouldRender, shouldChangeStyle];
}

export const TransitionWithUnmount = ({mountedStyle, unmountedStyle, renderToggle, delayTime, children}) => {
    const [shouldRenderChild, shouldChangeStyle] = useDelayUnmount(renderToggle, delayTime);
    return <span className={shouldChangeStyle ? mountedStyle : unmountedStyle}>{shouldRenderChild && children}</span>;
};
